export default {
  id: "magazin",
  brandIcon: "🛍️",
  defaultModule: "acceuil",
  footerNote: "Shop ERP · Retail Suite",
};
